<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
    <el-breadcrumb-item>工作汇报</el-breadcrumb-item>
    <el-breadcrumb-item>公告附件上传</el-breadcrumb-item>
  </el-breadcrumb>
  <el-card>
    <el-button @click="fileUp">上传附件</el-button>
    <el-table
    :data="accessoryList"
    border
    style="width: 100%">
    <el-table-column
      prop="fileCode"
      label="任务码"
      width="100">
    </el-table-column>
    <el-table-column
      prop="fileOldName"
      label="附件名称"
      width="130">
    </el-table-column>
    <el-table-column
      width="180"
      prop="fileSize"
      label="文件大小"
      :formatter="setSize">
    </el-table-column>
    <el-table-column
      width="180"
      prop="createDate"
      label="上传时间">
    </el-table-column>
    <el-table-column
      width="180"
      prop="fileSubUser"
      label="上传用户">
    </el-table-column>
    <!-- <el-table-column
      label="操作" 
      width="120">
      <template slot-scope="scope">
        <el-button  @click="deleteAnn(scope.row)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-shanchu"></use></svg></el-button>
</template>
    </el-table-column> -->
  </el-table>
  </el-card>
  <el-dialog
  :visible.sync="insertDialog"
  width="50%"
  destroy-on-close>
  <el-form :model="insertForm" status-icon  ref="ruleInsert" label-width="100px" class="demo-ruleForm">
  <el-form-item label="任务码：" prop="announcementCode">
    <el-input  v-model="insertForm.announcementCode"></el-input>
  </el-form-item>
  <el-form-item label="留言：" prop="message">
    <el-input  v-model="insertForm.message"></el-input>
  </el-form-item>
</el-form>
  <span>上传附件</span>
<el-upload
  class="upload-demo"
  drag
  action="https://jsonplaceholder.typicode.com/posts/"
  :auto-upload="false"
  :on-change="fileChange3"
   ref="uploadss"
  :on-remove="fileRemove3"
  accept=".html,.htm">
  <i class="el-icon-upload"></i>
  <div class="el-upload__text">将html文件拖到此处，或<em>点击上传</em></div>
</el-upload>
<span slot="footer" class="dialog-footer">
    <el-button @click="insertDialog = false">取 消</el-button>
    <el-button  type="primary" @click="subInsertForm">提交</el-button>
    <el-button type="primary" @click="resetResult">重 置</el-button>
  </span>
</el-dialog>
  </div>
</template>

<script>
export default {
    created(){
        this.getAccessory()
    },
    data(){
        return{
            insertDialog:false,
            insertForm:{
                announcementCode:'',
            },
            fileList7:[],
            fileList8:[],
            accessoryList:[],
        }
    },methods:{getAccessory(){
        this.axios.post("/announcement/selectAccessory?fileSubUser="+JSON.parse(localStorage.getItem('user')).username)
         .then(resp => { 
                       if(resp.data.status == 1) {
                            this.accessoryList=resp.data.result
                            console.log( this.accessoryList)
                                }else {
                               
                                       alert("出错")                          
                                }
                            })
                            .catch((err) => {
                                alert("出错了")
                                console.log(err)
                            }) 
    },setSize(row, column){
      return row.fileSize+' KB'
    },
        fileUp(){
         this.insertDialog=true
        },fileChange3(file, fileList){
        this.fileList7=fileList
      },fileRemove3(file, fileList){
        this.fileList7=fileList
      },subInsertForm(){
        if(this.fileList7.length==0){
           this.$message.error("请选择上传文件") 
         return false}
    this.fileList8=this.fileList7[0].raw
     let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
      const fd = new FormData();
      fd.append("FuJian",this.fileList8)
       fd.append("fileCode",this.insertForm.announcementCode)
       fd.append("message",this.insertForm.message)
       fd.append("fileSubUser",JSON.parse(localStorage.getItem('user')).username)
        this.axios.post("/announcement/insertAccessory",fd,config)
         .then(resp => { 
                       if(resp.data.status == 1) {
                                  this.$message.success("添加成功")
                                 this.resetResult()
                                 this.getAccessory()
                                   this.insertDialog=false    
                                }else {
                                  this.$message.error(resp.data.message)
                  
                                  this.fileList6=[],
                                  this.fileList4=[],
                                       alert("出错")                          
                                }
                            })
                            .catch((err) => {
                                alert("出错了")
                                console.log(err)
                            }) 
      },resetResult(){
        this.insertForm.announcementCode=''             
                                  this.fileList7=[]
                                  this.fileList8=[]
                                  this.$refs.uploadss.clearFiles()

      },
    }

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/work/teacher/Accessory.vue